export const rolesToRestrict = ["Company Admin", "Company Admin - Division", "Company Admin - Distribution"];

export const adminList = [
  "Company Admin",
  "Company Admin - Division",
  "Management",
  "Sr Management - HO",
  "Account Managers",
  "Account Manager",
  "Master",
  "Master Module",
];
